import Notify from 'api/Notify'
import { AppStore, showError } from 'utils'
import { useNotifyStore } from './../../stores/NotifyStore'

// const getNotification = async () => {
//   try {
//     const res = await Notify.getNotification()

//     return res
//   } catch (error: any) {
//     showError(error.message)
//   }
// }

const postMarkNotificationAsRead = async (notificationId: string) => {
  try {
    const res = await Notify.markNotificationAsRead(notificationId)
  } catch (error: any) {
    showError(error.message)
  }
}

const postMarkAllNotificationAsRead = async () => {
  try {
    const res = await Notify.markAllNotificationsAsRead()

    const results = await useNotifyStore.getState().updateNotifications()
  } catch (error: any) {
    showError(error.message)
  }
}

export { postMarkAllNotificationAsRead, postMarkNotificationAsRead }
